import React from 'react';
import styles from './index.module.scss';

const PublicationCardTitleV1 = ({ contentText, contentTag, contentName }) => {

  if (!contentText || contentText === 'none') {
    return null;
  }

  return (
    <div className={styles.publicationCardTitleV1}>
      <div className={styles.titleContainer}>
        <h3 className={styles.title}>{contentText}</h3>
        {contentName && contentName !== 'заголовок' && (
          <p className={styles.contentName}>{contentName}</p>
        )}
      </div>
    </div>
  );
};

export default PublicationCardTitleV1;
